import React, { useEffect, useRef, createRef } from "react";
import { FrameItem } from "./../QrFrameItems";
import classNames from "classnames";
import QRCodeStyling from "qr-code-styler";
import { useSelector } from "react-redux";
import QrTemplate from "../../../../../components/qrTemplate/QrTemplate";

const PreMadeFrameItem = ({ template, handleTemplateBtn, selectedId }) => {
  const { link, activePremadeTemplateId } = useSelector((state) => ({
    link: state.getQrLinkSlice.link,
    activePremadeTemplateId: state.preMadeTemplates.activePremadeTemplateId,
  }));
  const {
    patternColor,
    pattern,
    cornetsOuter,
    cornetsOuterColor,
    cornetsInterior,
    cornetsInteriorColor,
    isSingleColorDots,
    gradientDots,
    isSingleColorExternalEye,
    gradientExternalEye,
    isSingleColorInternalEye,
    gradientInternalEye,
    isSingleColorBackground,
    gradientBackground,
    qrBackgroundColor,
  } = template.qrSettings;

  let ref = useRef(createRef());

  const qrCode = new QRCodeStyling({
    width: 300,
    height: 300,
    type: "canvas",
  });

  useEffect(() => {
    let canvas = ref.current !== null && ref.current.querySelector("canvas");
    canvas && canvas.remove();

    const updateQrCode = async () => {
      qrCode.update({
        data: link,
        dotsOptions: {
          color: patternColor,
          type: pattern,
          gradient: isSingleColorDots ? null : gradientDots,
        },
        cornersSquareOptions: {
          color: cornetsOuterColor,
          type: cornetsOuter,
          gradient: isSingleColorExternalEye ? null : gradientExternalEye,
        },
        cornersDotOptions: {
          color: cornetsInteriorColor,
          type: cornetsInterior,
          gradient: isSingleColorInternalEye ? null : gradientInternalEye,
        },
        backgroundOptions: {
          gradient:
            isSingleColorBackground === false
              ? gradientBackground
              : {
                  colorStops: [
                    {
                      offset: 0,
                      color:
                        isSingleColorBackground == true
                          ? qrBackgroundColor
                          : "transparent",
                    },
                    {
                      offset: 1,
                      color:
                        isSingleColorBackground == true
                          ? qrBackgroundColor
                          : "transparent",
                    },
                  ],
                },
        },
        qrOptions: {
          errorCorrectionLevel:
            template?.qrOptions?.errorCorrectionLevel ?? "Q",
        },
      });
      qrCode.append(ref.current);
    };
    updateQrCode();
  }, [link]);

  return (
    <FrameItem
      onClick={() => handleTemplateBtn(template)}
      className={classNames(
        "d-flex justify-content-center align-items-center border rounded-1 p-2 ",
        {
          "border-primary":
            (selectedId ? selectedId : activePremadeTemplateId) === template.id,
          "border-border-gray":
            (selectedId ? selectedId : activePremadeTemplateId) !== template.id,
        }
      )}
    >
      <QrTemplate gRef={ref} canvasQr={true} template={template} />
    </FrameItem>
  );
};

export default PreMadeFrameItem;
